import * as types from './actionTypes'
// @ts-ignore
import { createRequestActions } from 'helpers'

export const uploadAdminWelcomeEmailImageRequest = (file: File | HTMLCanvasElement, mime: string, ext: string) => ({
  type: types.ADMIN_WELCOME_EMAIL_UPLOAD_IMAGE_REQUEST,
  payload: { file, mime, ext },
})

export const adminWelcomeEmail = {
  get: createRequestActions({
    request: types.ADMIN_WELCOME_EMAIL.GET.REQUEST,
    success: types.ADMIN_WELCOME_EMAIL.GET.SUCCESS,
    fail: types.ADMIN_WELCOME_EMAIL.GET.FAIL,
  }),
  post: createRequestActions({
    request: types.ADMIN_WELCOME_EMAIL.POST.REQUEST,
    success: types.ADMIN_WELCOME_EMAIL.POST.SUCCESS,
    fail: types.ADMIN_WELCOME_EMAIL.POST.FAIL,
  }),
  put: createRequestActions({
    request: types.ADMIN_WELCOME_EMAIL.PUT.REQUEST,
    success: types.ADMIN_WELCOME_EMAIL.PUT.SUCCESS,
    fail: types.ADMIN_WELCOME_EMAIL.PUT.FAIL,
  }),
}
